import { AppRoutingModule } from './app-routing.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// PrimeNG components
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MessageService } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { RadioButtonModule } from 'primeng/radiobutton';

// Components
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { TopBarComponent } from './top-bar/top-bar.component';

// Services
import { DataService } from './services/data-service.service';
import { DownloadComponent } from './download/download.component';
import { DonateComponent } from './donate/donate.component';
import { FooterComponent } from './footer/footer.component';
import { TourmanentsComponent } from './tourmanents/tourmanents.component';
import { environment } from 'src/environments/environment';
import { TournamentInfoComponent } from './tourmanents/components/tournament-info/tournament-info.component';
import { TeamsComponent } from './tourmanents/components/teams/teams.component';
import { LeadersComponent } from './tourmanents/components/leaders/leaders.component';
import { MatchComponent } from './tourmanents/components/match/match.component';
import { DmkRoundComponent } from './tourmanents/components/dmk-round/dmk-round.component';
import { EliminationRoundComponent } from './tourmanents/components/elimination-round/elimination-round.component';
import { BracketRoundComponent } from './tourmanents/components/bracket-round/bracket-round.component';
import { BracketComponent } from './tourmanents/components/bracket/bracket.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    TopBarComponent,
    DownloadComponent,
    DonateComponent,
    FooterComponent,
    TourmanentsComponent,
    TournamentInfoComponent,
    TeamsComponent,
    LeadersComponent,
    MatchComponent,
    DmkRoundComponent,
    EliminationRoundComponent,
    BracketRoundComponent,
    BracketComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    DropdownModule,
    FormsModule,
    HttpClientModule,
    InputSwitchModule,
    RadioButtonModule,
    TableModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
    }
    }),
    ToolbarModule
  ],
  providers: [
    { provide: "BASE_API_URL", useValue: environment.apiUrl },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    DataService,
    MessageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
